(function() {
    $(document).on('click', '.js-detailbewertung-toggler', function(e) {
        e.preventDefault();
        var $scope = $(this).closest('.js-detailbewertung-scope');
        $($scope).toggleClass('toggled');
    });
})();
